import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/connector_profiles',
    name: 'ConnectorProfile',
    component: {
      name: 'AdminConnectorProfile',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'connector_profile',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminConnectorProfileIndex',
        component: () => import('../views/ConnectorProfilesIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminConnectorProfileNew',
        component: () => import('../views/ConnectorProfileInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminConnectorProfileIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminConnectorProfileShow',
        component: () => import('../views/ConnectorProfileShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminConnectorProfileIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminConnectorProfileDetails',
            component: () => import('../views/ConnectorProfileDetails.vue'),
            meta: {
              backRoute: { name: 'AdminConnectorProfileIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminConnectorProfileEdit',
            component: () => import('../views/ConnectorProfileInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminConnectorProfileDetails' },
            },
          },
          {
            path: 'connector_actions',
            name: 'ConnectorAction',
            component: {
              name: 'AdminConnectorAction',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminConnectorProfileIndex' },
              resource: 'connector_action',
            },
            children: [
              {
                path: '',
                name: 'AdminConnectorActionIndex',
                component: () => import('../views/connectorAction/ConnectorProfileConnectorActions.vue'),
                meta: {
                  backRoute: { name: 'AdminConnectorProfileIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminConnectorActionNew',
                component: () => import('../views/connectorAction/ConnectorActionInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminConnectorActionIndex' },
                },
              },
              {
                path: ':connectorActionId(\\d+)',
                name: 'AdminConnectorActionShow',
                component: () => import('../views/connectorAction/ConnectorActionShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminConnectorActionIndex',
                  },
                  tArgs: route => ({ name: route?.params?.connectorActionId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminConnectorActionDetails',
                    component: () => import('../views/connectorAction/ConnectorActionDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminConnectorActionIndex' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminConnectorActionEdit',
                    component: () => import('../views/connectorAction/ConnectorActionInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminConnectorActionDetails' },
                    },
                  },
                ]
              }
            ],
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));